import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { sortBy } from 'lodash-es';
@Component({
    selector: 'multi-days',
    template: `
        <div class="d-flex mb-2 f-datepicker-multi-selectdays-header">
            <span style="font-size: 14px;" class="ml-3">{{ locales?.selected.split(',')[0] || 'å·²é'}} <span style="font-weight: bold;font-size: 17px;">{{selectedDates.length}}</span> {{locales?.selected.split(',')[1] ||'å¤©'}}</span>
            <span class="f-datepicker-multi-selectdays-clear" (click)="onClear($event)">{{ locales?.clearSelections || 'æ¸ç©º'}}</span>
        </div>
        <div #selecteditems style="height: 230px;overflow-y: auto;" class="ml-3 multi-date-select win11Scroll nobtn" (wheel)="$event.stopPropagation()">
            <ul [style.width.px]="167">
                <li class="d-flex align-items-center f-datepicker-multi-selectdays" *ngFor="let d of selectedDates" (click)="onSelectDateClick($event, d)">
                    {{d.value}} <span class="f-icon f-icon-close remove" title="{{ locales?.delete || 'å é¤'}}" (click)="onRemove($event, d)"></span>
                </li>
            </ul>
        </div>
    `,
    styles: [
        `
        .f-datepicker-multi-selectdays-header{
            height: 41px;border-bottom: 1px solid #E4E7EF;line-height: 40px;justify-content: space-between;
        }

        .f-datepicker-multi-selectdays {
            justify-content: space-between;color: #2D2F33;height: 30px;padding: 0 5px;border-radius: 6px;
            cursor: pointer;
        }

        .f-datepicker-multi-selectdays:hover {
            background: #F7F8FB;
        }

        .f-datepicker-multi-selectdays .remove {
            font-size: 12px;color: #C7CFDD;cursor: pointer;
        }

        .f-datepicker-multi-selectdays .remove:hover {
            color: #5f96f5;
        }

        .f-datepicker-multi-selectdays-clear {
            font-size: 13px;margin-right: 10px; color: #CCD1DD; cursor: pointer;
        }
        .f-datepicker-multi-selectdays-clear:hover {
            color: #5f96f5;
        }

        .mr14 {
            margin-right: 14px;
        }
        `
    ]
})

export class MultiSelectedDaysComponent implements OnInit, OnChanges {

    @Input() locales: any = {};

    @Input() selectedDates = [];
    @Output() removed = new EventEmitter();
    @Output() clear = new EventEmitter();
    @Output() clicked = new EventEmitter();


    @ViewChild('selecteditems') selecteditemsEl: ElementRef;


    constructor() { }

    ngOnInit() {

    }

    ngOnChanges(changes: SimpleChanges): void {
    }

    onRemove($event: MouseEvent, item) {
        $event.stopPropagation();
        this.removed.emit(item);
    }

    onClear($event: MouseEvent) {
        $event.stopPropagation();
        this.clear.emit();
    }

    onSelectDateClick($event, item) {
        $event.stopPropagation();
        this.clicked.emit(item);
    }
}